import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RECAPTCHA_SETTINGS, RecaptchaFormsModule, RecaptchaModule, RecaptchaSettings } from 'ng-recaptcha';
import { AppSettings } from './shared/App-Settings';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { LayoutComponent } from './shared/layout/layout.component';

import { UnauthorisedComponent } from './core/unauthorised/unauthorised.component';
import { LoggedoutComponent } from './core/loggedout/loggedout.component';

import { TitleService } from './services/title-service.service';
import { PagerService } from './services/pager-service';

import { MatTableModule } from '@angular/material/table';
import { NgbPaginationModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { MatSortModule } from '@angular/material/sort';
import { MatTabsModule } from '@angular/material/tabs';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ToastrModule } from 'ngx-toastr';
import { ForgotPasswordComponent } from './userSettings/forgot-password/forgot-password.component';
import { InterceptorService } from './core/interceptor.service';
import { ErrorInterceptorService } from './core/error-interceptor.service';
import { MalihuScrollbarModule } from 'ngx-malihu-scrollbar';

import { BsModalRef, ModalModule } from 'ngx-bootstrap/modal';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { PortalLandingComponent } from './portal-landing/portal-landing.component';
import { OrderByPipe } from './order-by.pipe';
import { appInitializer } from './core/app.initializer';
import { AuthenticationService } from './core/authentication.service';
import { RecoveryPasswordComponent } from './userSettings/recovery-password/recovery-password.component';
import { NO_ERRORS_SCHEMA } from '@angular/core';
import { CustomerFeedbackComponent } from './customer-feedback/customer-feedback.component';
import { MultiDatePicker } from './shared/multi-date-picker/multi-date-picker.component';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { DatePipe } from '@angular/common';
import { DirectServiceRatesComponent } from './direct-service-rates/direct-service-rates.component';
import { ReadMoreComponent } from './shared/read-more/read-more.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { AssignOverpackComponent } from './PackageManagement/assign-overpack/assign-overpack.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';




@NgModule({
  declarations: [
    AppComponent,
    LayoutComponent,
    LoginComponent,
    UnauthorisedComponent,
    LoggedoutComponent,
    ForgotPasswordComponent,
    PortalLandingComponent,    
    RecoveryPasswordComponent,
    // CustomerFeedbackComponent,
    DirectServiceRatesComponent,
    AssignOverpackComponent,
    // PostCutComponent,
    // ReadMoreComponent
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    SharedModule,
    RouterModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    // TypeaheadModule.forRoot(),  
    PaginationModule.forRoot(),
    MalihuScrollbarModule.forRoot(),
    //NgbPaginationModule,     
    MatTableModule,
    MatSortModule,
    MatTabsModule,
    MatFormFieldModule,
    NgbModule,
    ModalModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    CalendarModule.forRoot({ provide: DateAdapter, useFactory: adapterFactory }),
    NgSelectModule,
    InfiniteScrollModule,
    TypeaheadModule,
    RecaptchaModule,
    RecaptchaFormsModule
  ],
  providers: [

    TitleService,
    PagerService,
    BsModalRef,
    DatePipe,
    //{ provide: APP_INITIALIZER, useFactory: appInitializer, multi: true, deps: [AuthenticationService] },
    { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptorService, multi: true },
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: AppSettings.RE_CAPTCHA_SITEKEY,
      } as RecaptchaSettings,
    },
  ],
  bootstrap: [AppComponent],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA],
  exports: [NgbModule]
})
export class AppModule {

}
